module.exports = __webpack_public_path__ + "static/media/head.189ccc67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/head.svg
// module id = 848
// module chunks = 0